import React, { useMemo } from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Cell,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  chartGraph: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    borderRadius: "4px",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    transition: "all 0.2s ease-in-out",
  },
}));

export const ChartGraph = ({ data, contractorName }) => {
  const classes = useStyles();
  const yAxisLabel = useMemo(
    () => ({
      value: "КПЭ",
      angle: -90,
      position: "insideLeft",
      textAnchor: "bottom",
      fontSize: "16px",
      fontWeight: "bold",
    }),
    []
  );
  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      minHeight="400px"
      className={classes.chartGraph}
    >
      <ScatterChart
        width={400}
        height={400}
        title={contractorName}
        margin={{
          top: 30,
          right: 40,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis
          type="number"
          dataKey="n"
          name="N"
          padding={{ right: 20 }}
          unit=""
          tickCount={10}
          tick={{ stroke: "rgba(0, 0, 0, 0.396)" }}
        />
        <ReferenceLine y={12} />
        <ReferenceLine y={25} stroke="#B82C00" strokeWidth={2} />
        <ReferenceLine y={37} />
        <ReferenceLine y={50} stroke="#C8C115" strokeWidth={2} />
        <ReferenceLine y={62} />
        <ReferenceLine y={75} stroke="#6CB53F" strokeWidth={2} />
        <ReferenceLine y={87} />
        <ReferenceLine y={100} stroke="#04AF00" strokeWidth={2} />
        <YAxis
          label={yAxisLabel}
          type="number"
          domain={[0, 100]}
          dataKey="KPI"
          name="KPI"
          unit="%"
          tick={{ stroke: "rgba(0, 0, 0, 0.396)" }}
          tickCount={5}
          axisLine={false}
          tickLine={false}
          tickSize={6}
        />
        <Tooltip
          content={(props) => (
            <div
              style={{
                border: "#bbb 1.5px solid",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <p
                  style={{
                    margin: "0 0",
                    padding: "3px 7.5px",
                    backgroundColor: "#D9D9D9",
                  }}
                >
                  {props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.name}
                </p>
              </div>
              <div>
                <p
                  style={{
                    margin: "0 0",
                    padding: "3px 7.5px",
                    backgroundColor: "white",
                    color: "#000000",
                  }}
                >
                  КПЭ:{" "}
                  {props.payload &&
                  props.payload[0] != null &&
                  props.payload[0].payload.KPI < 26 ? (
                    <>
                      <span style={{ color: "#B82C00" }}>
                        {props.payload[0].payload.KPI}
                        {"%"}
                      </span>
                      <p
                        style={{
                          margin: "0 0",
                          padding: "0 7.5px",
                          backgroundColor: "white",
                          color: "#B82C00",
                        }}
                      >
                        {"Неэффективные"}
                      </p>
                    </>
                  ) : props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.KPI < 51 ? (
                    <>
                      <span style={{ color: "#B88F00" }}>
                        {props.payload[0].payload.KPI}
                        {"%"}
                      </span>
                      <p
                        style={{
                          margin: "0 0",
                          padding: "0 7.5px",
                          backgroundColor: "white",
                          color: "#B88F00",
                        }}
                      >
                        {"Низкоэффективные"}
                      </p>
                    </>
                  ) : props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.KPI < 76 ? (
                    <>
                      <span style={{ color: "#6CB53F" }}>
                        {props.payload[0].payload.KPI}
                        {"%"}
                      </span>
                      <p
                        style={{
                          margin: "0 0",
                          padding: "0 7.5px",
                          backgroundColor: "white",
                          color: "#6CB53F",
                        }}
                      >
                        {"Эффективные"}
                      </p>
                    </>
                  ) : props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.KPI <= 100 ? (
                    <>
                      <span style={{ color: "#04AF00" }}>
                        {props.payload[0].payload.KPI}
                        {"%"}
                      </span>
                      <p
                        style={{
                          margin: "0 0",
                          padding: "0 7.5px",
                          backgroundColor: "white",
                          color: "#04AF00",
                        }}
                      >
                        {"Высокоэффективные"}
                      </p>
                    </>
                  ) : null}
                </p>
                <hr
                  style={{
                    border: "0.5px solid #000000",
                    margin: "0 auto",
                    width: "100%",
                  }}
                />
                <p
                  style={{
                    margin: "0 0",
                    padding: "3px 7.5px",
                    backgroundColor: "white",
                    color: "#000000",
                  }}
                >
                  N:{" "}
                  {props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.n}
                </p>
                <p
                  style={{
                    margin: "0 0",
                    padding: "3px 7.5px",
                    backgroundColor: "white",
                    color: "#000000",
                  }}
                >
                  Wср:{" "}
                  {props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.w}
                </p>
                <p
                  style={{
                    margin: "0 0",
                    padding: "3px 7.5px",
                    backgroundColor: "white",
                    color: "#000000",
                  }}
                >
                  Tср:{" "}
                  {props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.t}
                </p>
                <p
                  style={{
                    margin: "0 0",
                    padding: "3px 7.5px",
                    backgroundColor: "white",
                    color: "#000000",
                  }}
                >
                  Rср:{" "}
                  {props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.r}
                </p>
                <p
                  style={{
                    margin: "0 0",
                    padding: "3px 7.5px",
                    backgroundColor: "white",
                    color: "#000000",
                  }}
                >
                  NPT:{" "}
                  {props.payload &&
                    props.payload[0] != null &&
                    props.payload[0].payload.NPT}
                </p>
              </div>
            </div>
          )}
        />
        <text
          x="40%"
          y="5"
          dominantBaseline="hanging"
          fontSize="16"
          fontWeight="bold"
        >
          {contractorName}
        </text>
        <text
          x="95%"
          y="89%"
          dominantBaseline="hanging"
          fontSize="16"
          fontWeight="bold"
        >
          {"N"}
        </text>
        <Scatter name="A school" data={data} fill="#8884d8">
          {data && data?.map((entry, index) => {
            if (entry.KPI < 26) {
              return <Cell key={`cell-${index}`} fill="#B82C00" />;
            }
            if (entry.KPI < 51) {
              return <Cell key={`cell-${index}`} fill="#B88F00" />;
            }
            if (entry.KPI < 76) {
              return <Cell key={`cell-${index}`} fill="#6CB53F" />;
            } else {
              return <Cell key={`cell-${index}`} fill="#04AF00" />;
            }
          })}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
};